// pushNotif.js — Helper untuk aktivasi Push Notification

const API_URL = 'https://skortes.com';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export function pushDidukungBrowser() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

export async function aktifkanPushNotif() {
  if (!pushDidukungBrowser()) {
    throw new Error('Browser ini tidak mendukung push notification (coba pakai Chrome/Edge terbaru, atau di iPhone tambahkan situs ini ke Home Screen dulu).');
  }

  const izin = await Notification.requestPermission();
  if (izin !== 'granted') {
    throw new Error('Izin notifikasi ditolak. Aktifkan lewat pengaturan browser kalau berubah pikiran.');
  }

  const registration = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;

  const token = localStorage.getItem('token');
  const keyRes = await fetch(`${API_URL}/api/push/vapid-public-key`);
  const { publicKey } = await keyRes.json();

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  const subJson = subscription.toJSON();
  await fetch(`${API_URL}/api/push/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ endpoint: subJson.endpoint, keys: subJson.keys }),
  });

  return true;
}

export async function cekStatusPushNotif() {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const res = await fetch(`${API_URL}/api/push/status`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    return !!data.adaSubscription;
  } catch {
    return false;
  }
}
